import AddressAutocomplete from './address-autocomplete.component';

export default AddressAutocomplete;
